import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { SwitchFieldComponent } from './../switch-field.component';

@Component({
  selector: 'app-basic-field',
  templateUrl: './basic-field.component.html',
  styleUrls: ['./../Field-Styles.scss'],
})
export class BasicFieldComponent extends SwitchFieldComponent implements OnInit {
  @Input() public RealValue;
  @Input() public Title: string = "Unset";
  
  // input limitors
  @Input() MaxLength: number = 50;
  @Input() MinLength: number = 0;

  // decore
  @Input() public Comment: string = "";
  @Input() public FrontDecor: string = "";
  @Input() public RearDecor: string = "";

  
  constructor() {
    super();
  }

  ngOnInit() {
  }
}
